<template>
  <div class="tankuang">
    <div class="mask"></div>
    <!--登录弹框-->
    <div class="login-pop" id="login-pop">
      <div class="close-pop close">
        <img src="../../assets/img/close2.png" alt>
      </div>
      <div class="account">
        <p>身份验证</p>
        <p style="text-align:center">为了您的账号安全，请先进行身份验证</p>
        <div class="form">
          <div class="row">
             <input type="text" placeholder="请输入手机号" class="code-num" v-model="phoneAnnot" v-on:input ="getBtn">
            <!-- <div class="code" v-text="isSend" @click="getCode"></div> -->
            <!-- <span class="bphone">使用手机 <span v-text="phoneAnnot"></span> 验证</span> -->
          </div>
          <p v-if="isphone" class="remain">请输入正确格式的手机号(11位纯数字)</p>
          <div class="row">
            <input type="text" placeholder="请输入验证码" class="code-num" v-model="code" v-on:input ="getBtn">
            <div class="code" v-text="isSend" @click="getCode"></div>
          </div>
        </div>
        <div :class='["look-more",a==0?"active":""]' @click="getVerify">验证</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      phoneAnnot:'',
      code:'',
      isphone:false,
      isSend: "发送验证码",
      a: 0
    };
  },
  mounted() {
    const self = this;
    $(".close-pop").click(function() {
      self.$parent.$data.panelModal = false;
    });
  },
  methods: {
    getBtn() {
      if (this.code != "") {
        this.a = 1;
      } else {
        this.a = 0;
      }
    },

    getCode(){ 
      /** 获取验证码*/
      var aa = /^1[34578][0-9]\d{8}$/;
      if (!aa.test(this.phoneAnnot)) {
        this.isphone = true;
        return false;
      } else {
        this.isphone = false;
      }
      this.$http
        .get("/api/user/001-sendSms", {
          params: {
            phone: this.phoneAnnot
          }
        })
        .then(res => {
          console.log(JSON.stringify(res));
          if (res.data.code == 0) {     
            this.$message('发送成功')
            this.timer(60);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }, 
    timer(time) {
      interval = setInterval(() => {
        time--;
        this.isSend = time + "s后重新发送";
        if (time <= 0) {
          clearInterval(interval);
          this.isSend = "获取验证码";
        }
      }, 1000);
      return;
    },
    getVerify(){  //验证
       this.$http
        .get("/api/user/006-changePhone", {
          params: {
            token:this.$store.state.userInfo.token,
            phone: this.phone,
            smsCode:this.code
          }
        })
        .then(res => {
          console.log(JSON.stringify(res));
          if (res.status == 200 && res.data.code == 0) {
            setTimeout(() => {
              this.$parent.$data.panelModal = false
            },300)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getVerify(){  //验证
       this.$http
        .get("/api/user/006-changePhone", {
          params: {
            token:this.$store.state.userInfo.token,
            phone: this.phone,
            smsCode:this.code
          }
        })
        .then(res => {
          console.log(JSON.stringify(res));
          if (res.status == 200 && res.data.code == 0) {
            setTimeout(() => {
              this.$parent.$data.panelModal = false
            },300)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>
<style scoped>
.bphone {
  font-weight: normal;
  line-height: 50px;
  margin: 0px;
  float: left;
  color: #010101;
  font-size: 16px;
}
.look-more {
  cursor: pointer;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
  pointer-events: none;
  cursor: not-allowed;
}
.login-pop .account p:nth-child(2){margin-bottom:30px;}
.remain{
  margin-bottom:0px!important;
  text-align: left!important;
  font-size:12px!important;
  color:red!important
  }
.login-pop {
  top: 40%;
}
.login-pop .account {
  height:380px;
  margin-top: 35px;
}
.login-pop .account .form .row {
  height: 50px;
}
.login-pop .account .form .row input,
.login-pop .account .form .row label,
.login-pop .account .form .row .code {
  margin-top: 0px;
}
.login-pop .account .look-more {
  margin-top: 45px;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
}
.login-pop .account .form .row label i {
  float: right;
}
</style>